<template>
<div class="flex flex-col justify-center py-12 sm:mx-6 2xl:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img class="mx-auto h-12 w-auto" src="mtcontrol.svg" alt="MTcontrol">
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-white py-8 px-4 shadow rounded-lg sm:px-10">
      <form class="space-y-6" onsubmit="event.preventDefault()" action="" method="GET">
        <div>
          <label for="rut" class="block 2xl:text-sm sm:text-xl font-medium text-gray-700">
            Usuario:
          </label>
          <div class="mt-1">
            <input v-model="user" id="user" name="user" type="user" autocomplete="user" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          </div>

          <label for="password" class="mt-6 block 2xl:text-sm sm:text-xl font-medium text-gray-700">
            Password:
          </label>
          <div class="mt-1">
            <input v-model="password" v-on:input="loginerror = false" id="password" name="password" type="password" autocomplete="password" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 2xl:text-sm sm:text-xl">
          </div>
        </div>
        <div v-if="loginerror" class="rounded-md bg-red-50 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <!-- Heroicon name: solid/x-circle -->
              <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="2xl:text-sm sm:text-xl font-medium text-red-800">
                Nombre de usuario o password incorrecto
              </h3>
            </div>
          </div>
        </div>

        <div>
          <button @click="checkAuth"  class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Entrar
          </button>
        </div>
      </form>
    </div>
  </div>
  <h3 class="mt-6 text-center text-2xl font-extrabold text-gray-900">
    MTSolutions
  </h3>
</div>
</template>

<script>
  export default {
    name: 'Login',
    data() {
      return {
        user: '',
        password: '',
        loginerror: false
      }
    },
    created() {
      this.$store.commit('resetState')
    },
    computed: {
      auth() {
        return this.$store.getters.auth;
      }
    },

    watch: {
      auth() {
        console.log("auth!", this.auth)
        if (this.auth.result === 'ok') {
          this.$store.commit('setState', {user: this.user})
          this.loginerror = false
          this.afterLogin()
        } else if (this.auth.result === 'changePassword'){
          this.$store.commit('setState', {user: this.user})
          this.loginerror = false
          this.$router.push("/form/changepassword/0")
        } else {
          this.loginerror = true
        }
      }
    },

    methods: {
      async afterLogin() {
        const response = await this.$http.get('flow/custom/formbuttons?method=login')
        if (response.data !== undefined && response.data.store !== undefined) {
          this.$store.commit('setState', response.data.store)
        }
        this.$router.push(response.data.jump)
      },
      getLocale() {
        const locale = Intl.NumberFormat().resolvedOptions().locale;
        return locale;
      },
      async checkAuth() {
        const locale = this.getLocale();
        this.$store.dispatch('login', { user: this.user, password: this.password, locale: locale })
      }
    }
  }
</script>
